var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-rating',{attrs:{"color":"yellow darken-3","background-color":"grey darken-1","empty-icon":"$ratingFull","hover":"","medium":"","readonly":_vm.readonly},on:{"input":function($event){return _vm.handleInput($event)}},model:{value:(_vm.rating),callback:function ($$v) {_vm.rating=$$v},expression:"rating"}})
}
var staticRenderFns = []

export { render, staticRenderFns }